import React from "react";

const AILoader = ({ text = "Checking Grammar", showText = true }) => {
  return (
    <div className="ailoader-page">
      <div className="ailoader-center" role="status" aria-live="polite">
        {/* Single SVG with two rings and one orbiting dot */}
        <svg className="rings-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" aria-hidden>
          <defs>
            <linearGradient id="g1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0A497B" />
              <stop offset="50%" stopColor="#60A5FA" />
              <stop offset="100%" stopColor="#0A497B" />
            </linearGradient>
          </defs>

          <g className="outer-arc">
            <circle cx="50" cy="50" r="45" fill="none" stroke="url(#g1)" strokeWidth="3" strokeLinecap="round" strokeDasharray="70 200" opacity="0.95" />
          </g>

          <g className="inner-arc">
            <circle cx="50" cy="50" r="35" fill="none" stroke="#0A497B" strokeWidth="2" strokeLinecap="round" strokeDasharray="50 150" opacity="0.45" />
          </g>

          <g className="orbit">
            <circle cx="50" cy="10" r="1.6" fill="#0A497B" />
          </g>
        </svg>

        {/* pulsing background circle (div to use CSS pulse easily) */}
        <div className="pulse-bg" aria-hidden></div>

        {/* center sparkle */}
        <div className="sparkle-wrap" aria-hidden>
          <svg viewBox="0 0 24 24" className="sparkle-main">
            <path d="M12 2L14 10L22 12L14 14L12 22L10 14L2 12L10 10L12 2Z" fill="#0A497B" opacity="0.95" />
          </svg>

          <svg viewBox="0 0 24 24" className="sparkle-small top-right">
            <path d="M12 2L13 8L19 9L13 10L12 16L11 10L5 9L11 8L12 2Z" fill="#60A5FA" />
          </svg>

          <svg viewBox="0 0 24 24" className="sparkle-small bottom-left">
            <path d="M12 2L13 8L19 9L13 10L12 16L11 10L5 9L11 8L12 2Z" fill="#60A5FA" />
          </svg>
        </div>
      </div>

      {showText && (
        <div className="ailoader-text">
          <div className="text-row">
            <span className="title">{text}</span>
            <div className="dots">
              <span className="dot dot1" />
              <span className="dot dot2" />
              <span className="dot dot3" />
            </div>
          </div>

          <div className="progress">
            <div className="progress-bar" />
          </div>

          <div className="status">This may take a moment...</div>
        </div>
      )}
    </div>
  );
};

export default AILoader;
